import i18next from "i18next";

function replaceLeaves(object: object) {
  const result: any = {};
  Object.keys(object).forEach((key) => {
    if (typeof object[key] === "string") {
      result[key] = "XXXXXX";
    } else {
      result[key] = replaceLeaves(object[key]);
    }
  });
  return result;
}

class WebpackI18nextBackend {
  private defaultLocale?: string;
  public type = "backend";

  init(services, backendOptions, { fallbackLng = "en-US" }: i18next.InitOptions) {
    if (typeof fallbackLng === "string") {
      this.defaultLocale = fallbackLng;
    } else if (typeof fallbackLng === "object") {
      this.defaultLocale = fallbackLng[0];
    }
  }

  read(language: string, namespace: string, callback: (err: Error | null, results?: object) => void) {
    const cb = (content: object) => {
      callback(null, content);
      return null;
    };

    if (language === this.defaultLocale) {
      import(`../../i18n/${namespace}.json`)
        .then(cb)
        .catch(callback);
    } else if (language === "debug") {
      import(`../../i18n/${namespace}.json`)
        .then((content: object) => {
          cb(replaceLeaves(content));
          return null;
        })
        .catch(callback);
    } else {
      import(`../../../handback/${language}/${namespace}.resjson`)
        .then(cb)
        .catch(callback);
    }
  }
}

export const webpackBackend = new WebpackI18nextBackend();
